import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@kodit/core/services';
import { DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-izloguj-upozorenje-dialog',
  templateUrl: './izloguj-upozorenje-dialog.component.html',
  styleUrls: ['./izloguj-upozorenje-dialog.component.scss'],
})
export class IzlogujUpozorenjeDialogComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription;

  /** Props */
  remainingTime: number = 30;
  timer: any;
  preuzimanjeUToku: boolean = false;

  constructor(
    private _authService: AuthService,
    private _dialogRef: DynamicDialogRef
  ) {
    this._subs = new Subscription();
  }

  ngOnInit(): void {
    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._izloguj();
      })
    );

    this.timer = setInterval(() => {
      // dok traje preuzimanje sesije ne odjavljujemo korisnika
      if (this.preuzimanjeUToku) {
        return;
      }

      this.remainingTime--;

      if (this.remainingTime <= 0) {
        this._izloguj();
      }
    }, 1000);
  }

  preuzmiSesiju() {
    if (this.preuzimanjeUToku) {
      return;
    }

    this.preuzimanjeUToku = true;
    this._subs.add(
      this._authService.takeOverSession().subscribe({
        next: (uspesno) => {
          if (!uspesno) {
            this._izloguj();
            return;
          }
          clearInterval(this.timer);
          this._dialogRef.close();
        },
        error: () => this._izloguj(),
      })
    );
  }

  private _izloguj() {
    clearInterval(this.timer);
    this._dialogRef.close();
    this._authService.logout();
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this._subs.unsubscribe();
  }
}
